import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ISalesGroupLookupService } from "../ISalesGroupLookupService";
import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SalesGroupLookupService
  extends BaseLookupService<string, CubiqTS.SalesGroupImpl>
  implements ISalesGroupLookupService
{
  constructor() {
    super(CubiqTS.SalesGroupImpl);
  }

  getSalesGroup(id: CubiqTS.Long): CubiqTS.SalesGroupImpl {
    if (id == undefined || id == null) return null;
    let salesGrp = this.getItem(id.toString());
    return salesGrp;
  }

  getItemKey(item: CubiqTS.SalesGroupImpl): string {
    if (item.groupId != undefined && item.groupId != null) return item.groupId.toString();
    return null;
  }
}
